const configuration =
{   
    "clientId": window.env.REACT_APP__CLIENT_ID,
    "baseUrl": process.env.REACT_APP__CORDOVA ? process.env.REACT_APP__BASE_URL_APP : window.env.REACT_APP__BASE_URL,  
    "baseUrlWeb": window.env.REACT_APP__BASE_URL,  
    "urlLogin": window.env.REACT_APP__URL_LOGIN,
    "urlApi": window.env.REACT_APP__URL_API,
    "urlArq": window.env.REACT_APP__URL_ARQ,
    "timeoutCache": window.env.REACT_APP__TIMEOUT_CACHE,
    "kbaUrl": window.env.REACT_APP__KBA_URL,   
    "captchaSiteKeyDesafio": window.env.REACT_APP__CAPTCHA_SITE_KEY_DESAFIO,
    "captchaSiteKeyInvisivel": window.env.REACT_APP__CAPTCHA_SITE_KEY_INVISIVEL,
    "meuGovBrSchemaIos": process.env.REACT_APP__GOVBR_SCHEMA_IOS,
    "meuGovBrSchemaAndroid": process.env.REACT_APP__GOVBR_SCHEMA_ANDROID,
    "firebaseConfig": {
        "apiKey": window.env.REACT_APP__FIREBASE_API_KEY,
        "projectId": window.env.REACT_APP__FIREBASE_PROJECT_ID,
        "appId": window.env.REACT_APP__FIREBASE_APP_ID,
        "minimumFetchIntervalMillis": window.env.REACT_APP__FIREBASE_MINIMUM_FETCH_INTERVAL
    },
    "avaliador":{
        "servicos":{
            "hiscre": parseInt(process.env.REACT_APP__AVALIADOR_HISCRE, 10),
            "extratoCnis": parseInt(process.env.REACT_APP__AVALIADOR_EXTRATOCNIS, 10),
            "eco": parseInt(process.env.REACT_APP__AVALIADOR_ECO, 10),
            "declaracao_atividade": parseInt(process.env.REACT_APP__AVALIADOR_DECLARACAO_ATIVIDADE, 10),
            "declaracao_nada_consta": parseInt(process.env.REACT_APP__AVALIADOR_DECLARACAO_NADA_CONSTA, 10),
            "carta_concessao": parseInt(process.env.REACT_APP__AVALIADOR_CARTA_CONCESSAO, 10),
            "carteira": parseInt(process.env.REACT_APP__AVALIADOR_CARTEIRA, 10),
            "drsci": parseInt(process.env.REACT_APP__AVALIADOR_DECLARACAO_REGULARIDADE_CONTRIBUINTE_INDIVIDUAL, 10),
            "simulador": parseInt(process.env.REACT_APP__AVALIADOR_SIMULADOR, 10),
            "certificado_deficiencia": parseInt(process.env.REACT_APP__AVALIADOR_CERTIFICADO_DEFICIENCIA, 10),
            "cat": parseInt(process.env.REACT_APP__AVALIADOR_CAT, 10),
            "ctc":parseInt(process.env.REACT_APP__AVALIADOR_CTC,10),
            "extrato_informacao_beneficio":parseInt(process.env.REACT_APP__AVALIADOR_EXTRATO_INFORMACAO_BENEFICIO,10),
            "extrato_ir":parseInt(process.env.REACT_APP__AVALIADOR_EXTRATO_IR,10),
            "laudo_medico":parseInt(process.env.REACT_APP__AVALIADOR_LAUDO_MEDICO,10),
            "ppp":parseInt(process.env.REACT_APP__AVALIADOR_PPP, 10),
            "pispasep":parseInt(process.env.REACT_APP__AVALIADOR_PISPASEP, 10),
            "concbi":parseInt(process.env.REACT_APP__AVALIADOR_CONCBI, 10),
            "ppbi":parseInt(process.env.REACT_APP__AVALIADOR_PPBI, 10)
        }
    },
    "biometria": {
        "tempoEntreVerificacoes": window.env.REACT_APP__BIOMETRIA_TEMPO_ENTRE_VERIFICACOES,
        "tempoLimiteVerificacoes": window.env.REACT_APP__BIOMETRIA_TEMPO_LIMITE_VERIFICACOES
    },
    "beneficioincapacidade": {
        "urlReagendamentoSABI": window.env.REACT_APP__URL_REAGENDAMENTO_SABI
    },
    "urlAtualizacaoCadastralRFB": window.env.REACT_APP__URL_ATUALIZACAO_CADASTRAL_RFB,
    "urlOracleInfinity": window.env.REACT_APP_SCRIPT_ORACLE_INFINITY,
    "requerimentoDescontoEntidadesProps": window.env.REACT_APP_REQUERIMENTO_DESCONTO_ENTIDADES,
	"procurador": {
        "perfis": {
            "consultaExtratos": window.env.REACT_APP__PROCURADOR_PERFIS.CONSULTA_EXTRATOS,
            "consultaPedidos": window.env.REACT_APP__PROCURADOR_PERFIS.CONSULTA_PEDIDOS,
        }
    }

}

export default configuration;
